import React from 'react';
import { ReferenceInput, AutocompleteInput, FormDataConsumer, useGetOne } from 'react-admin';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';


const customerOptionText = choice => choice?.name ? choice.name : '';
const addressOptionText = choice => choice.name ? `${choice?.name} ${choice?.full_address ? `(${choice.full_address})` : ''}` : '';

const AddressDetails = ({ id }) => {
	const { data: record } = useGetOne('addresses', { id });

	if (!record) {
		return null;
	}

	return (
		<>
			<Typography variant="h5">{record.name}</Typography>
			<Typography>{record.street}</Typography>
			<Typography>{record.zipcode} {record.city}</Typography>
			<Typography>{record.country}</Typography>
			<Typography>{record.vat_number}</Typography>
		</>
	);
};

const CustomerReferenceInput = ({ label = 'Customer', source = 'customer_id', reference = 'customers', ...props }) => (
	<Grid container>
		<Grid size={{ xs: 12, md: 6 }} sx={{ '.MuiFormControl-root': { maxWidth: '100%' } }}>
			<ReferenceInput sort={{ field: 'name', order: 'ASC' }} label={label} source={source} reference={reference} {...props} allowEmpty>
				<AutocompleteInput optionText={customerOptionText} size="small" />
			</ReferenceInput>
			<FormDataConsumer>
				{({ formData, ...rest }) => (
					<ReferenceInput
						sort={{ field: 'name', order: 'ASC' }}
						label="Invoicing address"
						reference="addresses"
						source="invoicing_address_id"
						allowEmpty
						filter={formData.customer_id && { customer_id: formData.customer_id }}
						helperText={false}
						{...rest}

					>
						<AutocompleteInput optionText={addressOptionText} />
					</ReferenceInput>
				)}
			</FormDataConsumer>
		</Grid>
		<Grid size={{ xs: 12, md: 6 }}>
			<Box mx={3}>
				<FormDataConsumer>
					{({ formData }) => (
						formData.invoicing_address_id && <AddressDetails id={formData.invoicing_address_id} />
					)}
				</FormDataConsumer>
			</Box>
		</Grid>
	</Grid>
);

export default CustomerReferenceInput;
